export default class ExtraPublicInfo {
    constructor(newslinks) {
        this.newslinks = newslinks;
    }
}